<template>
<v-container fluid class="fullscreen">
  <v-row no-gutters>
    <v-col cols="12" md="12" class="pa-2">
      <v-card>
        <v-card-title>
          <v-row no-gutters>
            <v-col cols="12" md="3" class="px-2">
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="290px"
                v-model="fromMeun"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromDateValue"
                    label="From Date"
                    prepend-icon="event"
                    hide-details
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :max="new Date().toISOString().substr(0, 10)" :type="datePickerType" v-model="fromDate" @input="fromMeun = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3" class="px-2">
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="290px"
                v-model="toMeun"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toDateValue"
                    label="To Date"
                    prepend-icon="event"
                    hide-details
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :max="new Date().toISOString().substr(0, 10)" :type="datePickerType" v-model="toDate" @input="toMeun = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3" class="px-2 pt-3">
              <v-autocomplete
                v-model="selectedIncomeType"
                :items="incomeTypeList"
                item-text="incomeTypeName"
                label="Income Type"
                prepend-icon="local_atm"
                return-object
                hide-details
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" class="px-2 pt-3">
              <v-autocomplete
                v-model="selectedAccount"
                item-text="profileName"
                :items="accountList"
                prepend-icon="group"
                label="User Account"
                return-object
                hide-details
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="10" md="6">
              <v-radio-group v-model="dateType" row hide-details>
                <v-radio label="Day" value="date"></v-radio>
                <v-radio label="Month" value="month"></v-radio>
                <v-radio label="Year" value="year"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="2" md="6" class="pt-5 px-2 text-right">
              <v-btn color="primary" depressed fab small @click="searchIncomeReport">
                <v-icon>search</v-icon>
              </v-btn>

              <v-btn depressed fab small class="mx-1" color="primary" outlined>
                <v-icon>help</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12" md="12" class="pa-2 pt-0">
      <v-card>
        <v-card-title class="pa-0">
          <v-row no-gutters>
            <v-col cols="6" md="5" class="py-4 px-3">
              Income Report
              <button icon type="button" v-on:click="onexport">
                <v-icon color="primary">assignment</v-icon>
              </button>
            </v-col>
            <v-col cols="6" md="4" offset-md="3" class="text-left text-md-right">
              <v-alert
                v-if="incomeReportList.total>0"
                type="success"
                border="left"
                class="ma-2"
                dense
              >
                <b>Total {{incomeReportList.total | defaultPaymentFormat}}</b>
              </v-alert>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12" md="12">
      <v-data-iterator
        :items="incomeReportList.reportList"
        class="text-center px-2"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:default="props">
          <v-row no-gutters>
            <v-col v-for="item in props.items" :key="item.reportTitle" cols="12" md="3">
              <v-card class="card-border ma-1">
                <v-card-title class="primary white--text">
                  <v-icon color="white" class="mr-2">event</v-icon>
                  <h5>{{ item.reportTitle }}</h5>
                </v-card-title>
                <v-divider></v-divider>
                <div class="pa-3">
                  <v-layout wrap row no-gutters>
                    <v-flex xs2 md2 class="subtitle-1 font-weight-bold text-right"></v-flex>
                    <v-flex xs5 md5 class="subtitle-1 font-weight-bold text-left">Income Type</v-flex>
                    <v-flex xs5 md5 class="subtitle-1 font-weight-bold text-right">Amount</v-flex>
                    <v-flex xs12 md12>
                      <template v-for="(incomeType,i) in item.ieDtoList">
                        <v-layout wrap row :key="i" no-gutters>
                          <v-flex xs2 md2 text-center>
                            <v-btn
                              @click="detailMore(item.reportTitle,incomeType.typeId)"
                              color="primary"
                              depressed
                              small
                              icon
                            >
                              <v-icon>visibility</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-flex xs5 md5 text-left class="pt-1">{{incomeType.typeName}}</v-flex>
                          <v-flex
                            xs5
                            md5
                            text-right
                            class="pt-1"
                          >{{incomeType.amount | defaultPaymentFormat}}</v-flex>
                        </v-layout>
                      </template>
                    </v-flex>
                    <v-flex xs12>
                      <v-divider></v-divider>
                    </v-flex>
                    <v-flex xs12 class="text-right">
                      <div>{{item.totalPrice | defaultPaymentFormat}}</div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-col>
  </v-row>
  </v-container>
  </template>
</template>
<script>
import incomeReportService from "../service/IncomeReportService";
import accountUserService from "../service/AccountUserService";
import incomeService from "../service/IncomeService";
import XLSX from "xlsx";
export default {
  data() {
    return {
      incomeType: {},
      selectedAccount: { userAccountId: 0, profileName: "ALL" },
      selectedIncomeType: { incomeTypeId: 0, incomeTypeName: "ALL" },
      accountList: [],
      incomeTypeList: [],
      incomeReportList: {},
      toDate: new Date().toISOString().substr(0, 10),
      fromDate: new Date().toISOString().substr(0, 10),
      toMeun: false,
      fromMeun: false,
      dateType: "date",
      datePickerType: "date",
    };
  },
  computed: {
    toDateValue: {
      get: function () {
        var toDatetemp = "";
        toDatetemp = this.formatDate(this.toDate);
        return toDatetemp;
      },
      set: function (value) {
        this.toDate = value;
      },
    },
    fromDateValue: {
      get: function () {
        var fromDatetemp = "";
        fromDatetemp = this.formatDate(this.fromDate);
        return fromDatetemp;
      },
      set: function (value) {
        this.fromDate = value;
      },
    },
  },
  mounted: function () {
    this.getAccount();
    this.getIncomeType();
    let i = 0;
    if (this.$route.query.incomeTypeName != undefined) {
      this.selectedIncomeType.incomeTypeName = this.$route.query.incomeTypeName;
      i++;
    }
    if (this.$route.query.incomeTypeId != undefined) {
      this.selectedIncomeType.incomeTypeId = this.$route.query.incomeTypeId;
      i++;
    }
    if (this.$route.query.userAccountId != undefined) {
      this.selectedAccount.userAccountId = this.$route.query.userAccountId;
      i++;
    }
    if (this.$route.query.profileName != undefined) {
      this.selectedAccount.profileName = this.$route.query.profileName;
      i++;
    }
    if (this.$route.query.dateType != undefined) {
      this.dateType = this.$route.query.dateType;
      i++;
    }
    if (this.$route.query.fromDate != undefined) {
      this.fromDateValue = this.formatDate(this.$route.query.fromDate);
      i++;
    }
    if (this.$route.query.toDate != undefined) {
      this.toDateValue = this.formatDate(this.$route.query.toDate);
      i++;
    }
    if (i == 7) {
      this.searchIncomeReport();
    }
  },
  methods: {
    searchHistory: function (
      fromDate,
      toDate,
      incomeTypeId,
      incomeTypeName,
      userAccountId,
      profileName,
      dateType
    ) {
      let query = {
        fromDate: fromDate,
        toDate: toDate,
        incomeTypeId: incomeTypeId,
        incomeTypeName: incomeTypeName,
        userAccountId: userAccountId,
        profileName: profileName,
        dateType: dateType,
      };
      this.$router
        .replace({
          name: "incomeReport",
          query,
        })
        .catch(() => {});
    },
    detailMore: function (reportTitle, typeId) {
      let query = {
        typeId: typeId,
        reportTitle: reportTitle,
        dateType: this.dateType,
      };
      this.$router
        .push({
          name: "income",
          query,
        })
        .catch(() => {});
    },
    searchIncomeReport: function () {
      incomeReportService
        .getIncomeReportList(
          this.formatDateUrl(this.fromDateValue),
          this.formatDateUrl(this.toDateValue),
          this.selectedIncomeType.incomeTypeId,
          this.dateType,
          this.selectedAccount.userAccountId
        )
        .then((response) => {
          this.searchHistory(
            this.fromDateValue,
            this.toDateValue,
            this.selectedIncomeType.incomeTypeId,
            this.selectedIncomeType.incomeTypeName,
            this.selectedAccount.userAccountId,
            this.selectedAccount.profileName,
            this.dateType
          );
          this.incomeReportList = response;
        });
    },
    getIncomeType: function () {
      incomeService.getIncomeType().then((response) => {
        this.incomeTypeList.splice(0, this.incomeTypeList.length);
        this.incomeTypeList.push(
          { incomeTypeId: 0, incomeTypeName: "ALL" },
          ...response
        );
        // this.selectedIncomeType={ incomeTypeId: 0, incomeTypeName: "ALL" };
      });
    },
    getAccount: function () {
      accountUserService.getAccount().then((response) => {
        this.accountList.splice(0, this.accountList.length);
        this.accountList.push(
          { userAccountId: 0, profileName: "ALL" },
          ...response
        );
        // this.selectedAccount={ userAccountId: 0, profileName: "ALL" };
      });
    },
    formatDateUrl(date) {
      //if (!date) return null;
      if (this.dateType == "month") {
        const [month, year] = date.split("-");
        return `01-${month}-${year}`;
      } else if (this.dateType == "year") {
        const [year] = date.split("-");
        return `01-01-${year}`;
      }
      return date;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (this.dateType == "date") {
        // const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      } else if (this.dateType == "month") {
        // const [year, month, day] = date.split("-");
        return `${month}-${year}`;
      } else {
        // const [year, month, day] = date.split("-");
        return `${year}`;
      }
    },
    onexport() {
      var excelList = [];
      var header = {};
      header.date = "Date";
      header.deliverName = "Type Name";
      header.times = "Amount";
      excelList.push(header);

      var reportList = this.incomeReportList.reportList;
      for (var i = 0; i < reportList.length; i++) {
        var report = reportList[i];
        var date = report.reportTitle;

        var subReportList = report.ieDtoList;
        for (var j = 0; j < subReportList.length; j++) {
          var subReport = subReportList[j];
          var data = {};
          data.date = date;
          data.deliverName = subReport.typeName;
          data.times = subReport.amount;
          excelList.push(data);
        }
        var data = {};
        data.date = date;
        data.deliverName = "Total ";
        data.times = report.totalPrice;
        excelList.push(data);
      }

      var data = {};
      data.date = "Total ";
      data.deliverName = this.incomeReportList.total;
      excelList.push(data);

      var pokemonWS = XLSX.utils.json_to_sheet(excelList, {
        skipHeader: true,
      });

      pokemonWS["!cols"] = [{ width: 13 }, { width: 20 }, { width: 10 }];

      var workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, pokemonWS, "incomeReport");
      XLSX.writeFile(workbook, "incomeReport" + ".xlsx");
    },
  },
};
</script>
<style scoped>
.fullscreen {
  height: 92vh;
}
</style>